//index.js
import "./HomePage.scss";
import React, { useState, useEffect } from "react";
import data from "../../data/dealerPackages.json";
import Header from "../../components/ui/StickyHeader";
import Footer from "./Footer";
import Button from "../../components/ui/Button";
import TextBlock from "../../components/ui/TextBlock";
import LogoCard from "../../components/ui/LogoCard";
import Tile from "./PackageCard.js";
import DealerPackagesSelector from "./DealerPackagesSelector";
// import strategyDeckPDF from "../../assets/BMW-WR-Digital-Programs-Strategy-Deck.pdf";
import mobileHeaderImage from "../../assets/hero-bg-mobile.png";
const Home = () => {
  //for DealerPackagesSelector
  const [selectedCategory, setSelectedCategory] = useState("Move Up");
  const [dataState, setDataState] = useState([]);

  useEffect(() => {
    if (data && data.packages && data.packages[selectedCategory]) {
      setDataState(data.packages[selectedCategory]);
    }
  }, [selectedCategory]);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  return (
    <>
      <Header />

      {/* ------------ hero ------------ */}
      <div className="hero-container-wrapper">
        <div
          className="hero-container"
          style={{
            "--mobile-header-bg": `url(${mobileHeaderImage})`,
          }}
        >
          <TextBlock
            hat="2026 BMW WESTERN REGION TIER 3 DIGITAL PROGRAMS"
            title={
              <>
                0% AGENCY FEES,
                <br />
                BUILT TO DRIVE PERFORMANCE.
              </>
            }
            paragraph="Media packages designed to drive inventory visibility, VDP engagement, and qualified leads."
            type="h1"
            color="white"
            align="center"
          />
          <div className="button-container">
            <Button link="/enroll" styleName="blue" size="large">
              Enroll Now
            </Button>
            {/* <a
							href={strategyDeckPDF}
							className="global_button white_button small_button"
							target="_blank"
							rel="noopener noreferrer">
							Explore the Strategy
						</a> */}
          </div>
        </div>
      </div>

      <div className="home-container">
        {/* ------------ world cup end ------------ */}
        {/* ------------ program overview ------------ */}
        <div className="program-overview-container">
          <TextBlock
            title="Bring in-market shoppers to your website with the BMW Western
				Region Digital Program"
            type="sectionHeader"
            color="black"
            align="center"
          />

          <div className="columns-container">
            <div className="column">
              <TextBlock
                // hat="0% Fees"
                title="Low-Funnel Traffic"
                paragraph="Bring high-intent shoppers directly to your showroom with a strategy built for conversion."
                type="spec"
                color="black"
                align="left"
              />
              <TextBlock
                title="Qualified Leads"
                paragraph="Capture and convert active shoppers through precision-targeted lead-gen platforms."
                type="spec"
                color="black"
                align="left"
              />
            </div>

            <div className="column image-column">
              <video
                src={require("../../assets/theixPhone.mp4")}
                className="vertical-image"
                autoPlay
                loop
                muted
                playsInline
              />
            </div>

            <div className="column">
              <TextBlock
                // hat="50-75%"
                title="Maximum Efficiency"
                paragraph="100% of your budget goes to working media. BMW covers all agency fees to ensure your investment works harder."
                type="spec"
                color="black"
                align="left"
              />
              <TextBlock
                title="Increased VDP Views"
                paragraph="Drive qualified traffic to specific New Vehicle Detail Pages to move aged and core inventory."
                type="spec"
                color="black"
                align="left"
              />
            </div>
          </div>
        </div>

        {/* ------------ live dashboard ------------ */}
        <div className="live-dashboard-container">
          <TextBlock
            title="Live Dashboard and Content Access"
            subtitle="Includes dashboard access to review performance of campaigns in real-time along with creative integration to review live creative."
            type="sectionHeader"
            color="black"
            align="center"
          />
          <div className="image-container">
            <img
              src={require("../../assets/looker.png")}
              alt="Live Dashboard"
              className="live-dashboard-image" //TODO: CREATE MOBILE COMPONENT FOR IMG
            />
          </div>
        </div>

        {/* ------------ program packages ------------ */}
        <div className="program-packages-container">
          {/* ------------ program packages > how the program works ------------ */}
          <div className="how-program-works-top-container">
            <div className="columns-container ">
              <div className="column">
                <TextBlock
                  title="How the Program Works"
                  paragraph="Maximize Inventory Visibility with Dynamic Precision."
                  type="sectionHeader"
                  color="black"
                  align="left"
                />
              </div>
              <div className="column">
                <TextBlock
                  paragraph="Drive high-intent traffic directly to your Vehicle Detail Pages by strategically positioning your current inventory and local dealership. "
                  type="p-block"
                  color="black"
                  fontSize="22"
                  fontWeight="300"
                />
              </div>
            </div>
            <img
              src={require("../../assets/howProgramWorks.png")}
              alt="BMW Car"
              className="small-featured-image"
            />
          </div>

          <div className="how-program-works-tile-container">
            <div className="columns-container">
              <div className="column">
                <LogoCard
                  styleName="vertical"
                  size="small"
                  alignment="left"
                  backgroundImage={require("../../assets/programImgs/adv.png")}
                  title="Fast Onboarding"
                  description="Starting March 1, campaigns will roll out in phases to ensure a smooth and strategic launch."
                />
              </div>

              <div className="column">
                <LogoCard
                  styleName="vertical"
                  size="small"
                  alignment="left"
                  backgroundImage={require("../../assets/programImgs/dyn.png")}
                  title="Dynamic Inventory"
                  description="Dynamic Inventory Campaigns drive results by maximizing relevance, and boosting website visits."
                />
              </div>
              <div className="column">
                <LogoCard
                  styleName="vertical"
                  size="small"
                  alignment="left"
                  backgroundImage={require("../../assets/programImgs/cont.png")}
                  title="Continuous Optimization"
                  description="Included in our service, monthly performance consultations provide direct access to a dedicated Customer Success team. Expect personalized insights and thoughtful optimization to drive sustained performance."
                />
              </div>
              <div className="column">
                <LogoCard
                  styleName="vertical"
                  size="small"
                  alignment="left"
                  backgroundImage={require("../../assets/programImgs/trans.png")}
                  title="Transparent Reporting"
                  description="Access live dashboards that align performance data directly with your dealership KPIs."
                />
              </div>
            </div>
          </div>
        </div>

        {/* ------------ dealer packages ------------ */}
        <div className="dealer-packages-container" id="dealer-packages-anchor">
          <TextBlock
            title="Program Packages"
            // paragraph="Dealers must enroll in two of the Always On Programs (Dynamic Inventory, Core ICE, or Core EV) in order to be eligible for additional BMW heavy up dollars. "
            type="sectionHeader"
            align="center"
          />

          <DealerPackagesSelector handleCategoryChange={handleCategoryChange} />

          <div className="columns-container">
            {Array.isArray(dataState) && dataState.length > 0 ? (
              dataState.map((plan, index) => (
                <div className="column" key={index}>
                  <Tile
                    size="large"
                    title={plan.title}
                    description={plan.description}
                    cost={plan.cost}
                    pill={plan.pill}
                    disclaimer={plan.disclaimer}
                    listSpecs={plan.listSpecs}
                    keyModels={plan.keyModels}
                    tactics={plan.tactics}
                    cta={plan.cta}
                  />
                </div>
              ))
            ) : (
              <div>No data available for the selected category.</div>
            )}
          </div>
          <p
            className="disclaimer"
            style={{ textAlign: "center", marginTop: "50px" }}
          >
            <span>*Enrollment Deadline February 28th</span>
          </p>
        </div>

        {/* ------------ program packages ------------ */}
        <div className="program-packages-container">
          <TextBlock
            hat="PROGRAM PACKAGES 2026"
            type="sectionHeader"
            align="center"
          />

          {/* ------------ program packages > ev/phev and ice------------ */}
          <div className="ev-phev-container">
            <div className="columns-container ">
              <div className="column">
                <TextBlock
                  title="Move Up Campaign"
                  paragraph="Increase consideration amongst non-premium owners by demystifying BMW ownership."
                  type="sectionHeader"
                  color="black"
                />
                <div className="audiences-section">
                  <h4 className="audiences-title">Audiences</h4>
                  <div className="audiences-list">
                    <div className="audience-item">
                      <img
                        src={require("../../assets/solidCheck.png")}
                        alt="Arrow"
                        className="audience-arrow"
                      />
                      <span>
                        Qualified Honda, Toyota households (and in some markets
                        Subaru)
                      </span>
                    </div>
                    <div className="audience-item">
                      <img
                        src={require("../../assets/solidCheck.png")}
                        alt="Arrow"
                        className="audience-arrow"
                      />
                      <span>Sedan and SUV Low Shared Audiences</span>
                    </div>
                  </div>
                </div>
                <img
                  src={require("../../assets/ev.png")}
                  alt="EV/PHEV Core Model"
                  className="featured-image"
                />
              </div>
              <div className="column">
                <TextBlock
                  title="Luxury Campaign"
                  paragraph="Reach in-market luxury shoppers with our best offers and product highlights including performance, technology and drivetrain choice."
                  type="sectionHeader"
                  color="black"
                />
                <div className="audiences-section">
                  <h4 className="audiences-title">Audiences</h4>
                  <div className="audiences-list">
                    <div className="audience-item">
                      <img
                        src={require("../../assets/solidCheck.png")}
                        alt="Arrow"
                        className="audience-arrow"
                      />
                      <span>In-Market Luxury Auto Intenders</span>
                    </div>
                    <div className="audience-item">
                      <img
                        src={require("../../assets/solidCheck.png")}
                        alt="Arrow"
                        className="audience-arrow"
                      />
                      <span>In-Market for Lexus</span>
                    </div>
                  </div>
                </div>
                <img
                  src={require("../../assets/ice.png")}
                  alt="ICE Core Model"
                  className="featured-image"
                />
              </div>
            </div>

            {/* ------------ program packages > dynamic inventory ------------ */}
            <div className="dynamic-inventory-container">
              <div className="columns-container ">
                <div className="column">
                  <TextBlock
                    title="Dynamic Inventory Campaign"
                    paragraph="Strategically position vehicles to drive shopping across your New Vehicle Detail pages."
                    type="sectionHeader"
                    color="black"
                    align="left"
                  />
                </div>
                <div className="column">
                  <TextBlock
                    paragraph="Dynamic Inventory Campaigns drive results by showcasing personalized, real-time vehicle listings to in-market shoppers, maximizing relevance, and boosting website visits."
                    type="p-block"
                    color="black"
                    fontSize="22"
                    fontWeight="300"
                  />
                </div>
              </div>

              <div className="columns-container">
                <div className="column">
                  <img
                    src={require("../../assets/dynamicInventory.png")}
                    alt="Media Icon"
                    className="small-featured-image"
                  />
                </div>
                <div className="column">
                  <LogoCard
                    styleName="horizontal"
                    alignment="center"
                    logoUrl={require("../../assets/meta.png")}
                    logoAlt="Meta Logo"
                    logoText="AIAs"
                    title="Meta's Automotive Inventory Ads (AIAs)"
                    description="Turn interest into action by reaching in-market
								car buyers with personalized, up-to-date
								listings, tailored to their needs."
                  />
                  {/* 
									<LogoCard
										styleName="horizontal"
										alignment="center"
										logoUrl={require("../../assets/google.png")}
										logoAlt="Meta Logo"
										logoText="VLA"
										title="Google's Vehicle Listing Ads (VLAs)"
										description="Connect with ready-to-buy shoppers by showcasing
								real-time inventory directly in search results,
								driving increased traffic to your site."
									/> */}
                </div>
              </div>
            </div>
          </div>

          {/* ------------ program packages > in-language meta campaigns ------------ */}
          <div className="in-language-container">
            <div className="columns-container ">
              <div className="column">
                <TextBlock
                  title="In-Language Meta Campaigns"
                  type="sectionHeader"
                  align="left"
                />
              </div>
              <div className="column">
                <TextBlock
                  paragraph="Target Spanish, Mandarin, Korean, and Hindi-speaking audiences by delivering tailored, culturally relevant marketing messages in their native languages to enhance engagement and drive conversions."
                  type="p-block"
                  fontSize="22"
                  fontWeight="300"
                />
              </div>
            </div>
            <div className="columns-container">
              <div className="column">
                <img
                  src={require("../../assets/language.png")}
                  alt="Media Icon"
                  className="small-featured-image"
                />
              </div>
              <div className="columns-container">
                <div className="column">
                  <LogoCard
                    styleName="vertical"
                    size="large"
                    alignment="left"
                    logoUrl={require("../../assets/meta.png")}
                    logoAlt="Meta Logo"
                    title="Research/Analysis"
                    description="Our team conducts an in-depth demographic study
							within your local market to ensure we are maximizing
							our opportunity to reach native language speakers."
                  />
                </div>
                <div className="column">
                  <LogoCard
                    styleName="vertical"
                    size="large"
                    alignment="left"
                    logoUrl={require("../../assets/meta.png")}
                    logoAlt="Meta Logo"
                    title="Cultural Appropriateness"
                    description="We use copywriters from an industry-leading
							localization firm which leverages a transcreation
							approach which goes beyond simple translation. Our
							in-language content is created with the audience in
							mind."
                  />
                </div>
              </div>
            </div>
            <TextBlock
              disclaimer="*Final audiences will be based on market area and dealership priorities."
              type="disclaimer"
              align="center"
            />
          </div>
        </div>
      </div>

      <div className="">
        <Footer />
      </div>
    </>
  );
};

export default Home;
